module.exports = "/static/assets/58f076fce6f7e6d43f0cd275e20a6641.png";